import { Component, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { TicketBatch } from '../../models/entities/ticket-batch';
import { TicketService } from '../../services/ticket-service';
import { TicketBatchTicket } from '../../models/entities/ticket-batch-ticket';
import { TicketBatchTicketWidgetComponent } from '../ticket-batch-ticket-widget/ticket-batch-ticket-widget.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'ticket-batch-widget',
    templateUrl: './ticket-batch-widget.component.html',
    styleUrls: ['./ticket-batch-widget.component.scss']
})

export class TicketServiceWidgetComponent extends BaseWidget implements AfterViewInit {

  ticketBatch             : TicketBatch = new TicketBatch();
  branchs                 : Branch[]    = null;

  expeditionForecastDate  : Date;
  

  constructor(
      protected controlTablesService  : ControlTablesService,
      protected ticketService         : TicketService,
      protected toastr                : ToastrService,
      public    leanUtilsService      : LeanUtilsService,
      protected dialog                : MatDialog) {
      super(toastr, leanUtilsService);
  }


//---------------------------------------------------------------------------------------
  ngOnInit(){    
    super.ngOnInit();         
    this.controlTablesService.branchsGet().then(branchs => {
      this.branchs = branchs; 
    }) 
    
    // New Asset Shipment case
    //------------------------------------------------------------------
    if (this.ticketBatch.inserted) {
        this.ticketBatch.branch = new Branch();
    }
    //------------------------------------------------------------------

  }
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
setEntity(ticketBatch: TicketBatch) {
  this.ticketBatch  = { ...ticketBatch };
  this.ticketBatch.ticketBatchTickets = [];
  if (ticketBatch.ticketBatchTickets) {
    for (let ticketBatchTicket of ticketBatch.ticketBatchTickets) {
      this.ticketBatch.ticketBatchTickets.push({ ...ticketBatchTicket });
    }
  }
}
//---------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.ticketBatch;
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  saveRow() : Promise<TicketBatch> {
      if (! this.checkData()) return;
      return this.ticketService.ticketBatchSave(this.ticketBatch);
  }
//--------------------------------------------------------------------------------------------------------


addTicketMode : boolean = false;
//--------------------------------------------------------------------------------------------------------
addTickets(){
  this.addTicketMode = true;
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
selectRow(ticketBatchTicket : TicketBatchTicket){
  let index = this.ticketBatch.ticketBatchTickets.indexOf(ticketBatchTicket);
  this.ticketService.ticketBatchTicketGet(ticketBatchTicket.id).then(result => {
    ticketBatchTicket = result;
    let dialogRef = this.dialog.open(TicketBatchTicketWidgetComponent, {autoFocus : false, hasBackdrop : false, data : {ticketBatchTicket : ticketBatchTicket, columns : this.childFields}} );
    dialogRef.afterClosed().subscribe(ticketBatchTicketResult => {
        if (ticketBatchTicketResult) {
          if (! ticketBatchTicketResult.deleted) {
            this.ticketBatch.ticketBatchTickets[index] = ticketBatchTicketResult;
          } else {
            this.ticketBatch.ticketBatchTickets.splice(index, 1);
          }
          this.ticketBatch.ticketBatchTickets = [...this.ticketBatch.ticketBatchTickets];
        } 
    });
  });
}
//--------------------------------------------------------------------------------------------------------


initChildFields = [];
switchToClosingMode(){
  this.closingMode = true;
  this.ticketBatch.processedByPerson = this.ticketBatch.role.person;
  this.initChildFields = [...this.childFields];
 /* this.childFields.forEach(field => {
    field.readOnly = true;
    if (field.prop == "done") field.readOnly = false;
    if (field.prop == "feedback") field.readOnly = false;
    if (field.prop == "visitDate") field.readOnly = false;
    if (field.prop == "duration") field.readOnly = false;
  });
*/
}

closingMode : any
closeTicketBatch(){
  if (! this.ticketBatch.processingDate) {
    this.showError("Prière de préciser la date de traitement du lot de tickets");
    return;
  }
  this.ticketService.ticketBatchClose(this.ticketBatch).then(ticketBatch => {
    this.ticketBatch = ticketBatch;
    this.closingMode = false;
    this.childFields = this.initChildFields;
  }) 
}

cancelTicketBatchClosing(){
  this.closingMode = false;
}
//--------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
checkData(): boolean{
  if ( (! this.ticketBatch.assignedToRole)) {
    this.showError("Prière de préciser le rôle auquel est affecté le lot de tickets");
    return false;
  }
  if ( (! this.ticketBatch.forecastDate)) {
    this.showError("Prière de préciser la date prévue");
    return false;
  }

  return true;
}
//---------------------------------------------------------------------------------------
 
}
